import MyFiancesPage from "components/pages/MyFinancesPage";
import ExternalDemoPage from "components/pages/ExternalDemoPage";
import { BCMSRecord, useBCMSContext  ,useCCTM } from "@bcm-dev/bcms-vite";
import Classes from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

const EXTERNAL_PFM_PURPOSE = "tab_my_finance(my_finance_external)";

function mainNavHasExternalPurpose(xml) {
    if (!xml || typeof xml.querySelector !== "function") {
        return false;
    }

    const mainNav = xml.querySelector('[id="mainNav"]');
    if (!mainNav || typeof mainNav.querySelectorAll !== "function") {
        return false;
    }

    const nodes = mainNav.querySelectorAll("[purpose]");
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].getAttribute("purpose") === EXTERNAL_PFM_PURPOSE) {
            return true;
        }
    }

    return false;
}

export default function CaptureQuickTourPersonalFinance(props) {
    const context = useBCMSContext();
    const { branding } = context.state;
    const options = branding && branding.options ? branding.options : {};
    BCMSRecord.globalControllerFor(Classes, context);
    const hasMyFinances = options.pfm21_abi22 === "true";
    const xml = useCCTM();
    const showExternalPFM = mainNavHasExternalPurpose(xml);

    if (!hasMyFinances) {
        const message = `This capture is only shown when "*My Finances" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }

    if (showExternalPFM) {
        return <ExternalDemoPage  demo="pfm25"/>;
    }

    return <MyFiancesPage />;
}
